'use client';

import { useCallback, useMemo } from 'react';
import classnames from 'classnames';

import { Icon } from '@personly/libs-widgets';
import { settingsIcon } from '@personly/libs-icons';

import { useConsents } from '../../providers/consents';

const className = classnames(
  'flex',
  'flex-row',
  'text-sm',
  'cursor-pointer',
  'opacity-45',
  'border-background-title-color'
);

interface Props {
  showSettings: string;
  hideSettings: string;
}

const ConsentSettingsToggle = ({ showSettings, hideSettings }: Props) => {
  const { consentSettingsOpen, setConsentSettingsOpen } = useConsents();

  const text = useMemo(
    () => (consentSettingsOpen ? hideSettings : showSettings),
    [consentSettingsOpen, hideSettings, showSettings]
  );

  const onClick = useCallback(
    () => setConsentSettingsOpen((value) => !value),
    [setConsentSettingsOpen]
  );

  return (
    <div className={className} onClick={() => onClick()}>
      <div className="pr-1">
        <Icon type={'light'} icon={settingsIcon} fixedWidth size={'xl'} />
      </div>
      <div>{text}</div>
    </div>
  );
};

export default ConsentSettingsToggle;
